(function () {
  function parseTLL() {
    const el = document.getElementById("tll-json");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function norm(s) { return (s || "").toString().trim().toLowerCase(); }
  function removeDiacritics(str) { return (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }

  // "liste_cp" : multi-ligne OU "CP:Ville,CP:Ville,..."
  function parseListe(liste) {
    const out = [];
    if (!liste) return out;
    const trimmed = String(liste).trim();
    let parts = [];

    if (/\n/.test(trimmed)) parts = trimmed.split(/\r?\n/);
    else if (/,/.test(trimmed)) parts = trimmed.split(/,\s*(?=\d{5}\s*:)/g);
    else parts = [trimmed];

    parts.forEach(item => {
      const L = item.trim();
      if (!L) return;
      const m = L.split(/[:;,\t ]+/);
      if (m.length >= 2) {
        const cp = (m[0] || "").trim();
        const city = (m.slice(1).join(" ") || "").trim();
        if (/^\d{5}$/.test(cp)) out.push({ cp, city });
      } else if (/^\d{5}$/.test(L)) {
        out.push({ cp: L, city: "" });
      }
    });

    return out;
  }

  function buildDeliveryRows(tll) {
    if (!tll || !Array.isArray(tll.zones)) return [];
    const rows = [];
    tll.zones.forEach(z => {
      let zoneId = z.id || "";
//      alert(zoneId);
      if (window.innerWidth <  900) { zoneId = "Z" + zoneId.charAt(5);}
      parseListe(z.liste_cp).forEach(it => {
        rows.push({ commune: it.city || "", cp: it.cp || "", zone: zoneId });
      });
    });

    // dédoublonne
    const seen = new Set();
    return rows.filter(r => {
      const k = `${r.cp}|${norm(removeDiacritics(r.commune))}|${r.zone}`;
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }

  function escapeHtml(s) {
    return (s ?? "").toString()
      .replaceAll("&", "&amp;").replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;").replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function renderTable(mountEl, rows) {
    let sortKey = "commune";
    let sortDir = "asc";
    let query = "";

    const keyStr = (r, k) => norm(removeDiacritics((r[k] ?? "").toString()));

    const compare = (a, b, key) => {
      if (key === "cp") {
        const na = parseInt(a.cp, 10), nb = parseInt(b.cp, 10);
        if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
      }
      return keyStr(a, key).localeCompare(keyStr(b, key), "fr", { sensitivity: "base" });
    };

    function arrow(key) {
      if (sortKey !== key) return "↕";
      return sortDir === "asc" ? "↑" : "↓";
    }

    function th(key, label) {
      return `
        <th style="text-align:left; padding:10px; border-bottom:1px solid rgba(0,0,0,.08);">
          <button type="button" data-sort-key="${key}"
            style="all:unset; cursor:pointer; font-weight:600; display:inline-flex; gap:8px; align-items:center;">
            <span>${label}</span><span style="opacity:.7;">${arrow(key)}</span>
          </button>
        </th>`;
    }

    function apply() {
      let filtered = rows;

      if (query.trim()) {
        const q = norm(removeDiacritics(query));
        filtered = rows.filter(r =>
          keyStr(r, "commune").includes(q) ||
          keyStr(r, "cp").includes(q) ||
          keyStr(r, "zone").includes(q)
        );
      }

      const sorted = [...filtered].sort((a, b) => {
        const c = compare(a, b, sortKey);
        return sortDir === "asc" ? c : -c;
      });

      mountEl.innerHTML = `
<!--        <div style="display:flex; gap:10px; align-items:center; margin-bottom:10px;">
          <input id="ibpZoneFilter" type="search" placeholder="Filtrer (ville, CP, zone)…"
            style="flex:1; padding:10px 12px; border:1px solid rgba(0,0,0,.15); border-radius:10px;" />
          <div style="font-size:16px; opacity:.75; white-space:nowrap;">${sorted.length}/${rows.length}</div>
        </div>
-->
        <div style="overflow:auto; border:1px solid rgba(0,0,0,.08); border-radius:12px;">
          <table class="ibp-table">
           <thead class="ibp-thead">
              <tr>
                ${th("commune", "Commune")}
                ${th("cp", "     CP  ")}
<!--                ${th("zone", "Zone")}   -->
              </tr>
            </thead>
            <tbody>
              ${
                sorted.length ? sorted.map(r => `
                  <tr class="ibp-row" data-cp="${escapeHtml(r.cp)}" data-commune="${escapeHtml(r.commune)}"
                      style="cursor:pointer;">
                    <td style="padding:10px 12px; border-bottom:1px solid rgba(0,0,0,.06);">${escapeHtml(r.commune)}</td>
                    <td style="padding:10px 12px; border-bottom:1px solid rgba(0,0,0,.06);">${escapeHtml(r.cp)}</td>
<!--                     <td style="padding:10px 12px; border-bottom:1px solid rgba(0,0,0,.06);">${escapeHtml(r.zone)}</td>  -->
                  </tr>
                `).join("") :
                `<tr><td colspan="3" style="padding:14px; opacity:.7;">Aucun résultat.</td></tr>`
              }
            </tbody>
          </table>
        </div>

        <div style="font-size:14px; opacity:.7; margin-top:8px;">
          Clique une commune pour remplir le champ “Code postal ou nom de ville”.
        </div>
      `;

      // filtre
      const filterEl = mountEl.querySelector("#ibpZoneFilter");
      if (filterEl) {
        filterEl.value = query;
        filterEl.addEventListener("input", (e) => { query = e.target.value || ""; apply(); }, { once: true });
      }

      // tri
      mountEl.querySelectorAll("[data-sort-key]").forEach(btn => {
        btn.addEventListener("click", () => {
          const key = btn.getAttribute("data-sort-key");
          if (sortKey === key) sortDir = (sortDir === "asc" ? "desc" : "asc");
          else { sortKey = key; sortDir = "asc"; }
          apply();
        }, { once: true });
      });

      // clic ligne -> remplit l'input du panier
      mountEl.querySelectorAll(".ibp-row").forEach(row => {
        row.addEventListener("click", () => {
          const cp = row.getAttribute("data-cp") || "";
          const commune = row.getAttribute("data-commune") || "";
          const input = document.getElementById("cart-cp-ville");
          if (!input) return;

            document.getElementById("ibp-open-communes").innerHTML = "Voir les communes livrées";
            document.getElementById("ibp-open-communes").title = "Voir";
            document.getElementById("ibp-communes-panel").style.display = "none";
          // Format lisible (à adapter si ton moteur veut "CP:Ville")
          input.value = commune ? `${commune}` : cp;

          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
          input.focus();
        }, { once: true });
      });
    }

    apply();
  }

  // ---- Init au clic (zéro coût au chargement)
  document.addEventListener("DOMContentLoaded", () => {
    const btn = document.getElementById("ibp-open-communes");
    const panel = document.getElementById("ibp-communes-panel");
    if (!btn || !panel) return;

    let inited = false;

    btn.addEventListener("click", (e) => {
      e.preventDefault();

      // toggle display
      const isOpen = panel.style.display !== "none";
      panel.style.display = isOpen ? "none" : "block";
      if (isOpen) return;

      if (!inited) {
        const tll = parseTLL();
        const rows = buildDeliveryRows(tll);
        renderTable(panel, rows);
        inited = true;
      }
    });
  });
})();
